import angular from 'angular';
import Home from './home/home';
import News from './news/news';
import Events from './events/events';
import Apps from './apps/apps';
import Offices from './offices/offices';
import Settings from './settings/settings';
import LoaderScreen from './loaderScreen/loaderScreen';

let componentModule = angular.module('app.components', [
  Home,
  News,
  Events,
  Apps,
  Offices,
  Settings,
  LoaderScreen
]).run(($transitions) => {
  'ngInject';
  // reset scroll state of main view when a transition is completed
  $transitions.onSuccess({}, () => {
    document.getElementById('main-view').scrollTop = 0;
  });
}).name;

export default componentModule;



// WEBPACK FOOTER //
// ./client/app/components/components.js